import { render, staticRenderFns } from "./AuthenticationBar.vue?vue&type=template&id=781b8e40&scoped=true&"
import script from "./AuthenticationBar.vue?vue&type=script&lang=js&"
export * from "./AuthenticationBar.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationBar.vue?vue&type=style&index=0&id=781b8e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781b8e40",
  null
  
)

component.options.__file = "AuthenticationBar.vue"
export default component.exports